import { Slab } from "@/types/slab";
import { SlabCard } from "@/components/SlabCard";
import { SlabList } from "@/components/SlabList";

interface SlabResultsProps {
  isLoading: boolean;
  error: unknown;
  slabs: Slab[];
  viewMode: 'grid' | 'list';
  onSlabClick: (slab: Slab) => void;
}

export function SlabResults({ isLoading, error, slabs, viewMode, onSlabClick }: SlabResultsProps) {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center text-destructive">
        Failed to load slabs. Please try again later.
      </div>
    );
  }

  if (viewMode === 'grid') {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {slabs.map((slab) => (
          <SlabCard
            key={slab.id}
            slab={slab}
            onClick={() => onSlabClick(slab)}
          />
        ))}
      </div>
    );
  }

  return (
    <SlabList
      slabs={slabs}
      onSlabClick={onSlabClick}
    />
  );
}